<template>
  <el-dialog :title="title" :visible.sync="currentValue" width="600px" custom-class="delProductDialog-class" append-to-body @open="open" @opened="opened">
    <p class="tip">删除后不可恢复，请填写删除原因。</p>
    <el-form class="my-form" ref="form" :model="form" :rules="rules" size="large" label-position="top">
      <el-form-item label="删除原因" prop="product_name">
        <el-input ref="input" type="textarea" class="description-class" size="large" v-model="form.deleted_reason" maxlength="100" placeholder="请输入删除原因" show-word-limit clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <div></div>
      <div class="footer-right">
        <span class="text-btn-active" @click="currentValue = false" style="margin-right: 24px;">取消</span>
        <wf-button type="danger" @click="onSubmit" :disabled="isDisabled" :loading="loading">删除</wf-button>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import api from '@/services/api/product/product'
export default {
  props: ['value', 'id', 'title', 'isSeries'],
  data() {
    return {
      form: {
        // 删除原因
        deleted_reason: ''
      },
      rules: {
        deleted_reason: [
          { required: true, trigger: "change", message: "删除原因不能为空" },
        ],
      },
      loading: false
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
    isDisabled() {
      return !this.form.deleted_reason
    }
  },
  methods: {
    opened() {
      this.$refs.input.focus()
    },
    open() {
      this.form.deleted_reason = ''
    },
    async onSubmit() {
      await this.$refs.form.validate()
      console.log('---------', this.isSeries)
      if (this.isSeries) {
        await api.productSeriesDelete({ id: this.id, deleted_reason: this.form.deleted_reason })
      } else {
        await api.productsDelete({ id: this.id, deleted_reason: this.form.deleted_reason })
        this.$message({
        message: '删除成功',
        type: 'success'
        })
      }
      this.currentValue = false
      this.$emit('success', this.id)
    }
  },
}
</script>
<style lang="scss">
.delProductDialog-class {
  .el-dialog__body {
    min-height: 300px;
    position: relative;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog {
    border-radius: 8px;
  }
  .el-dialog__header {
    padding: 17px 24px;
    border-bottom: 1px solid #EEEEEE;
  }
  .my-form {
    .description-class  {
      .el-textarea__inner {
        background-color: #fff;
        height: 136px;
      }
    }

  }
  .tip {
    padding: 16px 0;
    padding-bottom: 32px;
    font-size: 16px;
    font-weight: bold;
  }
}
</style>
